import '@/i18n/template/projects/operation/store/modules/user.js'
import {
  startIdleTimeOutCheck,
  endIdleTimeOutCheck,
  setAuthData,
  clearAuthData,
  onAuthDateRefresh
} from '@/api/tokenApi'
import { setCbbHeader } from '@/api/index'
import { Message } from 'element-ui'
import i18n from '@/i18n'

let initalAuthData = localStorage.authData || ''
let userInfo = {}
if (initalAuthData) {
  try {
    initalAuthData = JSON.parse(initalAuthData)
    // token是否过期
    if (initalAuthData.expires_time > Date.now()) {
      setAuthData(initalAuthData)
      userInfo = initalAuthData.userInfo || {}
      // 兼容缓存的旧数据
      if (userInfo.roleId && !userInfo.roleList) {
        userInfo.roleList = [userInfo.roleId]
      }
      setCbbHeader({
        custId: '',
        staffId: userInfo.staffId,
        deptId: userInfo.deptId,
        userGrpCd: userInfo.userGrpCd,
        chnlDscd: userInfo.chnlDscd
      })
      startIdleTimeOutCheck(initalAuthData.expires_in)
    }
  } catch (e) {
    userInfo = {}
  }
}

onAuthDateRefresh(newAuthData => {
  try {
    let oldAuth = JSON.parse(localStorage.authData)
    localStorage.authData = JSON.stringify({
      ...oldAuth,
      access_token: newAuthData.access_token,
      refresh_token: newAuthData.refresh_token,
      user_secret: newAuthData.user_secret,
      expires_in: newAuthData.expires_in,
      expires_time: newAuthData.expires_time
    })
  } catch (e) {}
})

export default {
  namespaced: true,
  state: {
    login: !!userInfo.staffId,
    roleList: userInfo.roleList || [],
    userNm: userInfo.userNm || '',
    userId: userInfo.staffId || '',
    staffId: userInfo.staffId || '',
    imId: userInfo.imId || '',
    imPwd: userInfo.imId || '',
    userInfo: userInfo,
    status: 'Online',
    statusIndex: 0
  },
  getters: {
    // 是否是管理员(尚云内部账号)
    isAdmin(state) {
      let userGrpCd = state.userInfo?.userGrpCd || ''
      return userGrpCd.split(',').includes('admin')
    },
    // 是否是开发者(尚云内部账号 staffid 00230)
    isDeveloper(state) {
      return state.staffId === '00230'
    }
  },
  actions: {
    login(context, authData) {
      let data = authData.userInfo
      let imId = data.staffId.toLowerCase()
      data.userId = data.staffId
      data.staffNm = data.userNm
      data.loinIdNbr = data.loginId
      data.imId = imId
      data.imPwd = imId
      setCbbHeader({
        custId: '',
        staffId: data.staffId,
        deptId: data.deptId,
        userGrpCd: data.userGrpCd,
        chnlDscd: data.chnlDscd
      })
      startIdleTimeOutCheck(authData.expires_in)

      context.commit('login', data)
      context.commit('userInfo', authData.userInfo || {})
      localStorage.authData = JSON.stringify(authData)
      setAuthData(authData)
      return Promise.resolve(userInfo)
    },
    logout(context, logoutType) {
      if (logoutType === 'expired' && context.state.login) {
        // 防重复提示
        Message.error(i18n.t('loginExpired'))
      }
      localStorage.removeItem('authData')
      clearAuthData()
      setCbbHeader()
      endIdleTimeOutCheck()
      context.dispatch('chat/logout', null, { root: true })
      context.commit('logout')
    },
    statusChange(context, data) {
      context.commit('statusChange', data)
    }
  },
  mutations: {
    userInfo(state, data) {
      state.userInfo = data
    },
    login(state, data) {
      state.login = true
      state.userNm = data.userNm
      state.roleList = data.roleList
      if (data.roleId && !data.roleList) {
        state.roleList = [data.roleId]
      }
      state.userId = data.staffId
      state.staffId = data.staffId
      state.imId = data.imId
      state.imPwd = data.imPwd
    },
    logout(state) {
      state.login = false
      state.roleList = []
      state.userId = null
      state.staffId = ''
      state.userNm = ''
      state.imId = null
      state.imPwd = null
      state.userInfo = {}
    },
    statusChange(state, data) {
      state.status = data
    }
  }
}
